/*
  SalonID — compacte paginakoppen (okt 2026), gebruikt door de categoriepagina
  (sid-main-collection) en de paginakop (sid-page-hero).

  1. [data-sid-rotator]: een vinkjeslijst toont op mobiel één regel tegelijk
     en schuift om de paar seconden door (CSS in sid-brand.css).
  2. [data-sid-clamp]: de inleiding is ingekort tot een paar regels; de knop
     [data-sid-clamp-toggle] erna klapt hem open en dicht. De knop verschijnt
     alleen als er echt tekst wegvalt.
*/
(function () {
  var mobile = window.matchMedia('(max-width: 749px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function rotator(list) {
    if (list.dataset.sidReady) return;
    list.dataset.sidReady = 'true';
    var items = Array.prototype.slice.call(list.children);
    if (items.length < 2) return;
    var index = 0;
    var visible = true;
    function show(i) {
      items.forEach(function (item, n) {
        item.classList.toggle('is-active', n === i);
        item.classList.toggle('is-leaving', n === index && n !== i);
      });
      index = i;
    }
    list.classList.add('is-rotating');
    show(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(list);
    }
    setInterval(function () {
      if (!mobile.matches || calm.matches || !visible || document.hidden) return;
      show((index + 1) % items.length);
    }, 3200);
  }

  function clamp(text) {
    if (text.dataset.sidReady) return;
    text.dataset.sidReady = 'true';
    var toggle = text.nextElementSibling;
    if (!toggle || !toggle.hasAttribute('data-sid-clamp-toggle')) return;
    function measure() {
      if (text.classList.contains('is-open')) return;
      toggle.hidden = text.scrollHeight <= text.clientHeight + 2;
    }
    toggle.addEventListener('click', function () {
      var open = !text.classList.contains('is-open');
      text.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? toggle.getAttribute('data-less') : toggle.getAttribute('data-more');
    });
    measure();
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  function boot() {
    document.querySelectorAll('[data-sid-rotator]').forEach(rotator);
    document.querySelectorAll('[data-sid-clamp]').forEach(clamp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
